// removed by extract-text-webpack-plugin
module.exports = {"Sidebar":"_1E9BPa7bAGbEA2g6Fr_MQY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sidebar/styles.css
// module id = 663
// module chunks = 0